<template>
  <div class="l-container StudentsAdd">
    <p class="m-label">家庭選択</p>
    <table-c>
      <tr-c slot="tr-th">
        <td-c><input v-model="search.id" type="text" @keyup="searchTable()" placeholder="検索"></td-c>
        <td-c><input v-model="search.name" type="text" @keyup="searchTable()" v-focus></td-c>
        <td-c><input v-model="search.kana" type="text" @keyup="searchTable()"></td-c>
        <!-- <td&#45;c class="select"> -->
        <!--   <multiselect @select="searchTable()" v&#45;model="watchSearch.relationship" :options="relationship" label="name" placeholder="続柄" :show&#45;labels="false"></multiselect> -->
        <!-- </td&#45;c> -->
        <td-c class="select">
          <multiselect @select="searchTable()" v-model="watchSearch.pref" :options="pref" label="name" placeholder="" :show-labels="false"></multiselect>
        </td-c>
        <td-c><input v-model="search.address" type="text" @keyup="searchTable()"></td-c>
        <td-c><input v-model="search.tel1" type="text" @keyup="searchTable()"></td-c>
        <td-c><input v-model="search.tel2" type="text" @keyup="searchTable()"></td-c>
        <td-c><input v-model="search.fax" type="text" @keyup="searchTable()"></td-c>
        <td-c><input v-model="search.mail" type="text" @keyup="searchTable()"></td-c>
        <!-- <td&#45;c class="select"> -->
        <!--   <multiselect @select="searchTable()" v&#45;model="watchSearch.guidance_type" :options="guidance_type" label="name" placeholder="指導種類" :show&#45;labels="false"></multiselect> -->
        <!-- </td&#45;c> -->
        <!-- <td&#45;c class="select"> -->
        <!--   <multiselect @select="searchTable()" v&#45;model="watchSearch.unit" :options="unit" label="name" placeholder="件口" :show&#45;labels="false"></multiselect> -->
        <!-- </td&#45;c> -->
        <!-- <td&#45;c class="select"> -->
        <!--   <multiselect @select="searchTable()" v&#45;model="watchSearch.preferred_contact" :options="preferred_contact" label="name" placeholder="優先連絡先" :show&#45;labels="false"></multiselect> -->
        <!-- </td&#45;c> -->
        <td-c><input v-model="search.created_at" type="text" @keyup="searchTable()"></td-c>
      </tr-c>

      <tr-c slot="tr-th">
        <td-c><input v-model="search.not_id" type="text" @keyup="searchTable()" placeholder="除外"></td-c>
        <td-c><input v-model="search.not_name" type="text" @keyup="searchTable()"></td-c>
        <td-c><input v-model="search.not_kana" type="text" @keyup="searchTable()"></td-c>
        <!-- <td&#45;c class="select"> -->
        <!--   <multiselect @select="searchTable()" v&#45;model="watchSearch.not_relationship" :options="relationship" label="name" placeholder="続柄" :show&#45;labels="false"></multiselect> -->
        <!-- </td&#45;c> -->
        <td-c class="select">
          <multiselect @select="searchTable()" v-model="watchSearch.not_pref" :options="pref" label="name" placeholder="" :show-labels="false"></multiselect>
        </td-c>
        <td-c><input v-model="search.not_address" type="text" @keyup="searchTable()"></td-c>
        <td-c><input v-model="search.not_tel1" type="text" @keyup="searchTable()"></td-c>
        <td-c><input v-model="search.not_tel2" type="text" @keyup="searchTable()"></td-c>
        <td-c><input v-model="search.not_fax" type="text" @keyup="searchTable()"></td-c>
        <td-c><input v-model="search.not_mail" type="text" @keyup="searchTable()"></td-c>
        <!-- <td&#45;c class="select"> -->
        <!--   <multiselect @select="searchTable()" v&#45;model="watchSearch.not_guidance_type" :options="guidance_type" label="name" placeholder="指導種類" :show&#45;labels="false"></multiselect> -->
        <!-- </td&#45;c> -->
        <!-- <td&#45;c class="select"> -->
        <!--   <multiselect @select="searchTable()" v&#45;model="watchSearch.not_unit" :options="unit" label="name" placeholder="件口" :show&#45;labels="false"></multiselect> -->
        <!-- </td&#45;c> -->
        <!-- <td&#45;c class="select"> -->
        <!--   <multiselect @select="searchTable()" v&#45;model="watchSearch.not_preferred_contact" :options="preferred_contact" label="name" placeholder="優先連絡先" :show&#45;labels="false"></multiselect> -->
        <!-- </td&#45;c> -->
        <td-c><input v-model="search.not_created_at" type="text" @keyup="searchTable()"></td-c>
      </tr-c>

      <tr-c slot="tr-th">
        <th-c @click.native='sort("id")'>ID</th-c>
        <th-c @click.native='sort("f_name + l_name")'>名前</th-c>
        <th-c @click.native='sort("f_name_kana + l_name_kana")'>読み</th-c>
        <!-- <th&#45;c @click.native='sort("relationship")'>続柄</th&#45;c> -->
        <th-c @click.native='sort("pref")'>都道府県</th-c>
        <th-c @click.native='sort("address1 + address2")'>住所</th-c>
        <th-c @click.native='sort("tel1")'>TEL1</th-c>
        <th-c @click.native='sort("tel2")'>TEL2</th-c>
        <th-c @click.native='sort("fax")'>FAX</th-c>
        <th-c @click.native='sort("mail")'>MAIL</th-c>
        <!-- <th&#45;c @click.native='sort("guidance_type")'>指導種類</th&#45;c> -->
        <!-- <th&#45;c @click.native='sort("unit")'>件口</th&#45;c> -->
        <!-- <th&#45;c @click.native='sort("preferred_contact")'>優先連絡先</th&#45;c> -->
        <th-c @click.native='sort("created_at")'>登録日</th-c>
      </tr-c>
      <tr-c slot="tr-td" @click.native="getId(list)" v-for="(list, index) in orderedFamilies" :key="index.id">
        <template v-if="student.family_id === list.id">
          <td-c class="clicked">{{list.id}}</td-c>
          <td-c class="clicked">{{list.f_name}} {{list.l_name}}</td-c>
          <td-c class="clicked">{{list.f_name_kana}} {{list.l_name_kana}}</td-c>
          <!-- <template> -->
          <!--   <td&#45;c class="clicked" v&#45;if="list.relationship === 0">未選択</td&#45;c> -->
          <!--   <td&#45;c class="clicked" v&#45;if="list.relationship === 1">母</td&#45;c> -->
          <!--   <td&#45;c class="clicked" v&#45;if="list.relationship === 2">父</td&#45;c> -->
          <!--   <td&#45;c class="clicked" v&#45;if="list.relationship === 3">祖母</td&#45;c> -->
          <!--   <td&#45;c class="clicked" v&#45;if="list.relationship === 4">祖父</td&#45;c> -->
          <!--   <td&#45;c class="clicked" v&#45;if="list.relationship === 5">本人</td&#45;c> -->
          <!-- </template> -->
          <td-c class="clicked">
            <template v-if="list.pref === 0">未選択</template>
            <template v-if="list.pref === 1">北海道</template>
            <template v-if="list.pref === 2">青森県</template>
            <template v-if="list.pref === 3">秋田県</template>
            <template v-if="list.pref === 4">岩手県</template>
            <template v-if="list.pref === 5">山形県</template>
            <template v-if="list.pref === 6">宮城県</template>
            <template v-if="list.pref === 7">福島県</template>
            <template v-if="list.pref === 8">栃木県</template>
            <template v-if="list.pref === 9">山梨県</template>
            <template v-if="list.pref === 10">群馬県</template>
            <template v-if="list.pref === 11">茨城県</template>
            <template v-if="list.pref === 12">千葉県</template>
            <template v-if="list.pref === 13">埼玉県</template>
            <template v-if="list.pref === 14">東京都</template>
            <template v-if="list.pref === 15">神奈川県</template>
            <template v-if="list.pref === 16">静岡県</template>
            <template v-if="list.pref === 17">長野県</template>
            <template v-if="list.pref === 18">愛知県</template>
            <template v-if="list.pref === 19">岐阜県</template>
            <template v-if="list.pref === 20">新潟県</template>
            <template v-if="list.pref === 21">富山県</template>
            <template v-if="list.pref === 22">石川県</template>
            <template v-if="list.pref === 23">福井県</template>
            <template v-if="list.pref === 24">滋賀県</template>
            <template v-if="list.pref === 25">京都府</template>
            <template v-if="list.pref === 26">三重県</template>
            <template v-if="list.pref === 27">和歌山県</template>
            <template v-if="list.pref === 28">奈良県</template>
            <template v-if="list.pref === 29">大阪府</template>
            <template v-if="list.pref === 30">兵庫県</template>
            <template v-if="list.pref === 31">鳥取県</template>
            <template v-if="list.pref === 32">島根県</template>
            <template v-if="list.pref === 33">岡山県</template>
            <template v-if="list.pref === 34">広島県</template>
            <template v-if="list.pref === 35">山口県</template>
            <template v-if="list.pref === 36">高知県</template>
            <template v-if="list.pref === 37">徳島県</template>
            <template v-if="list.pref === 38">香川県</template>
            <template v-if="list.pref === 39">愛媛県</template>
            <template v-if="list.pref === 40">福岡県</template>
            <template v-if="list.pref === 41">佐賀県</template>
            <template v-if="list.pref === 42">長崎県</template>
            <template v-if="list.pref === 43">熊本県</template>
            <template v-if="list.pref === 44">宮崎県</template>
            <template v-if="list.pref === 45">大分県</template>
            <template v-if="list.pref === 46">鹿児島県</template>
            <template v-if="list.pref === 47">沖縄県</template>
          </td-c>
          <td-c class="clicked">{{list.address1}}{{list.address2}}</td-c>
          <td-c class="clicked">{{list.tel1}}</td-c>
          <td-c class="clicked">{{list.tel2}}</td-c>
          <td-c class="clicked">{{list.fax}}</td-c>
          <td-c class="clicked">{{list.mail}}</td-c>
          <!-- <template> -->
          <!--   <td&#45;c class="clicked" v&#45;if="list.guidance_type === 0">未選択</td&#45;c> -->
          <!--   <td&#45;c class="clicked" v&#45;if="list.guidance_type === 1">1人指導</td&#45;c> -->
          <!--   <td&#45;c class="clicked" v&#45;if="list.guidance_type === 2">2人同時指導</td&#45;c> -->
          <!-- </template> -->
          <!-- <template> -->
          <!--   <td&#45;c class="clicked" v&#45;if="list.unit === 0">未選択</td&#45;c> -->
          <!--   <td&#45;c class="clicked" v&#45;if="list.unit === 1">1件口</td&#45;c> -->
          <!--   <td&#45;c class="clicked" v&#45;if="list.unit === 2">2件口</td&#45;c> -->
          <!-- </template> -->
          <!-- <template> -->
          <!--   <td&#45;c class="clicked" v&#45;if="list.preferred_contact === 0">未選択</td&#45;c> -->
          <!--   <td&#45;c class="clicked" v&#45;if="list.preferred_contact === 1">携帯</td&#45;c> -->
          <!--   <td&#45;c class="clicked" v&#45;if="list.preferred_contact === 2">自宅</td&#45;c> -->
          <!-- </template> -->
          <td-c class="clicked">{{list.created_at.substring(0, 10)}}</td-c>
        </template>
        <template v-if="student.family_id !== list.id">
          <td-c>{{list.id}}</td-c>
          <td-c>{{list.f_name}} {{list.l_name}}</td-c>
          <td-c>{{list.f_name_kana}} {{list.l_name_kana}}</td-c>
          <!-- <template> -->
          <!--   <td&#45;c v&#45;if="list.relationship === 0">未選択</td&#45;c> -->
          <!--   <td&#45;c v&#45;if="list.relationship === 1">母</td&#45;c> -->
          <!--   <td&#45;c v&#45;if="list.relationship === 2">父</td&#45;c> -->
          <!--   <td&#45;c v&#45;if="list.relationship === 3">祖母</td&#45;c> -->
          <!--   <td&#45;c v&#45;if="list.relationship === 4">祖父</td&#45;c> -->
          <!--   <td&#45;c v&#45;if="list.relationship === 5">本人</td&#45;c> -->
          <!-- </template> -->
          <td-c>
            <template v-if="list.pref === 0">未選択</template>
            <template v-if="list.pref === 1">北海道</template>
            <template v-if="list.pref === 2">青森県</template>
            <template v-if="list.pref === 3">秋田県</template>
            <template v-if="list.pref === 4">岩手県</template>
            <template v-if="list.pref === 5">山形県</template>
            <template v-if="list.pref === 6">宮城県</template>
            <template v-if="list.pref === 7">福島県</template>
            <template v-if="list.pref === 8">栃木県</template>
            <template v-if="list.pref === 9">山梨県</template>
            <template v-if="list.pref === 10">群馬県</template>
            <template v-if="list.pref === 11">茨城県</template>
            <template v-if="list.pref === 12">千葉県</template>
            <template v-if="list.pref === 13">埼玉県</template>
            <template v-if="list.pref === 14">東京都</template>
            <template v-if="list.pref === 15">神奈川県</template>
            <template v-if="list.pref === 16">静岡県</template>
            <template v-if="list.pref === 17">長野県</template>
            <template v-if="list.pref === 18">愛知県</template>
            <template v-if="list.pref === 19">岐阜県</template>
            <template v-if="list.pref === 20">新潟県</template>
            <template v-if="list.pref === 21">富山県</template>
            <template v-if="list.pref === 22">石川県</template>
            <template v-if="list.pref === 23">福井県</template>
            <template v-if="list.pref === 24">滋賀県</template>
            <template v-if="list.pref === 25">京都府</template>
            <template v-if="list.pref === 26">三重県</template>
            <template v-if="list.pref === 27">和歌山県</template>
            <template v-if="list.pref === 28">奈良県</template>
            <template v-if="list.pref === 29">大阪府</template>
            <template v-if="list.pref === 30">兵庫県</template>
            <template v-if="list.pref === 31">鳥取県</template>
            <template v-if="list.pref === 32">島根県</template>
            <template v-if="list.pref === 33">岡山県</template>
            <template v-if="list.pref === 34">広島県</template>
            <template v-if="list.pref === 35">山口県</template>
            <template v-if="list.pref === 36">高知県</template>
            <template v-if="list.pref === 37">徳島県</template>
            <template v-if="list.pref === 38">香川県</template>
            <template v-if="list.pref === 39">愛媛県</template>
            <template v-if="list.pref === 40">福岡県</template>
            <template v-if="list.pref === 41">佐賀県</template>
            <template v-if="list.pref === 42">長崎県</template>
            <template v-if="list.pref === 43">熊本県</template>
            <template v-if="list.pref === 44">宮崎県</template>
            <template v-if="list.pref === 45">大分県</template>
            <template v-if="list.pref === 46">鹿児島県</template>
            <template v-if="list.pref === 47">沖縄県</template>
          </td-c>
          <td-c>{{list.address1}}{{list.address2}}</td-c>
          <td-c>{{list.tel1}}</td-c>
          <td-c>{{list.tel2}}</td-c>
          <td-c>{{list.fax}}</td-c>
          <td-c>{{list.mail}}</td-c>
          <!-- <template> -->
          <!--   <td&#45;c v&#45;if="list.guidance_type === 0">未選択</td&#45;c> -->
          <!--   <td&#45;c v&#45;if="list.guidance_type === 1">1人指導</td&#45;c> -->
          <!--   <td&#45;c v&#45;if="list.guidance_type === 2">2人同時指導</td&#45;c> -->
          <!-- </template> -->
          <!-- <template> -->
          <!--   <td&#45;c v&#45;if="list.unit === 0">未選択</td&#45;c> -->
          <!--   <td&#45;c v&#45;if="list.unit === 1">1件口</td&#45;c> -->
          <!--   <td&#45;c v&#45;if="list.unit === 2">2件口</td&#45;c> -->
          <!-- </template> -->
          <!-- <template> -->
          <!--   <td&#45;c v&#45;if="list.preferred_contact === 0">未選択</td&#45;c> -->
          <!--   <td&#45;c v&#45;if="list.preferred_contact === 1">自宅</td&#45;c> -->
          <!--   <td&#45;c v&#45;if="list.preferred_contact === 2">携帯</td&#45;c> -->
          <!--   <td&#45;c v&#45;if="list.preferred_contact === 3">勤務先</td&#45;c> -->
          <!--   <td&#45;c v&#45;if="list.preferred_contact === 4">その他</td&#45;c> -->
          <!-- </template> -->
          <td-c>{{list.created_at.substring(0, 10)}}</td-c>
        </template>
      </tr-c>
    </table-c>

    <p class="m-label">
      新規追加
      <span class="errors">
        <span v-if="!valid"> {{errors}} が入力されていません</span>
        <span v-if="valid"></span>
      </span>
    </p>

    <btn @click.native="reset">Reset</btn>

    <form class="h-adr" @submit.prevent="postStudent">
      <div class="form-wrapper">
        <student-form :student="student" :watch="watchStudent"></student-form>
      </div>

      <button type="submit" class="u-btn"><i class="fa fa-user-plus"></i>生徒情報を新規追加</button>
    </form>

  </div>
</template>

<script>
import { getAPIURL } from '@/store/getters.js'
import config from '@/settings/config.js'
const url = getAPIURL() + '/api/v1/families/search?limit=' + config.LIMIT

var obj = {
  timer: null,
  TIMER: null,
  COUNT: 1,
  offset: config.LIMIT,
  max: config.LIMIT + 1,
  url: url,
  pageName: 'family',
  pageNames: 'families'
}

let _ = window._
export default {
  directives: {
    focus: {
      inserted (el, binding) {
        el.focus()
        // console.log(el)
        // console.log(binding)
      }
    }
  },
  data () {
    return {
      asc: '',
      desc: '',
      sortState: 'desc',

      student: {
        family_id: '',
        state: 1,
        f_name: '',
        l_name: '',
        f_name_kana: '',
        l_name_kana: '',
        gender: 0,
        birthday: '0001/01/01',
        school_type: 0,
        school_name: '',
        grade_flag: 0,
        guidance_detail: '',
        takeover_time: '',
        inheritance_result: 0,
        next_contact_date: '',
        priority: 0,
        service_period_start: '0001/01/01',
        service_period_end: '0001/01/01',
        note: ''
      },

      watchStudent: {
        state: '',
        gender: '',
        school_type: '',
        inheritance_result: '',
        priority: ''
      },

      search: {
        id: '',
        name: '',
        kana: '',
        relationship: '',
        pref: '',
        address: '',
        tel1: '',
        tel2: '',
        fax: '',
        mail: '',
        guidance_type: '',
        unit: '',
        preferred_contact: '',
        created_at: '',

        not_id: '',
        not_name: '',
        not_kana: '',
        not_relationship: '',
        not_pref: '',
        not_address: '',
        not_tel1: '',
        not_tel2: '',
        not_fax: '',
        not_mail: '',
        not_guidance_type: '',
        not_unit: '',
        not_preferred_contact: '',
        not_created_at: ''
      },

      watchSearch: {
        relationship: '',
        pref: '',
        guidance_type: '',
        unit: '',
        preferred_contact: '',

        not_relationship: '',
        not_pref: '',
        not_guidance_type: '',
        not_unit: '',
        not_preferred_contact: ''
      },

      pref: [
        { name: '0. 未選択', value: 0 },
        { name: '1. 北海道', value: 1 },
        { name: '2. 青森県', value: 2 },
        { name: '3. 秋田県', value: 3 },
        { name: '4. 岩手県', value: 4 },
        { name: '5. 山形県', value: 5 },
        { name: '6. 宮城県', value: 6 },
        { name: '7. 福島県', value: 7 },
        { name: '8. 栃木県', value: 8 },
        { name: '9. 山梨県', value: 9 },
        { name: '10. 群馬県', value: 10 },
        { name: '11. 茨城県', value: 11 },
        { name: '12. 千葉県', value: 12 },
        { name: '13. 埼玉県', value: 13 },
        { name: '14. 東京都', value: 14 },
        { name: '15. 神奈川県', value: 15 },
        { name: '16. 静岡県', value: 16 },
        { name: '17. 長野県', value: 17 },
        { name: '18. 愛知県', value: 18 },
        { name: '19. 岐阜県', value: 19 },
        { name: '20. 新潟県', value: 20 },
        { name: '21. 富山県', value: 21 },
        { name: '22. 石川県', value: 22 },
        { name: '23. 福井県', value: 23 },
        { name: '24. 滋賀県', value: 24 },
        { name: '25. 京都府', value: 25 },
        { name: '26. 三重県', value: 26 },
        { name: '27. 和歌山県', value: 27 },
        { name: '28. 奈良県', value: 28 },
        { name: '29. 大阪府', value: 29 },
        { name: '30. 兵庫県', value: 30 },
        { name: '31. 鳥取県', value: 31 },
        { name: '32. 島根県', value: 32 },
        { name: '33. 岡山県', value: 33 },
        { name: '34. 広島県', value: 34 },
        { name: '35. 山口県', value: 35 },
        { name: '36. 高知県', value: 36 },
        { name: '37. 徳島県', value: 37 },
        { name: '38. 香川県', value: 38 },
        { name: '39. 愛媛県', value: 39 },
        { name: '40. 福岡県', value: 40 },
        { name: '41. 佐賀県', value: 41 },
        { name: '42. 長崎県', value: 42 },
        { name: '43. 熊本県', value: 43 },
        { name: '44. 宮崎県', value: 44 },
        { name: '45. 大分県', value: 45 },
        { name: '46. 鹿児島県', value: 46 },
        { name: '47. 沖縄県', value: 47 }
      ],

      relationship: [
        { name: '未選択', value: 0 },
        { name: '母', value: 1 },
        { name: '父', value: 2 },
        { name: '祖母', value: 3 },
        { name: '祖父', value: 4 },
        { name: '本人', value: 5 }
      ],

      guidance_type: [
        { name: '未選択', value: 0 },
        { name: '1人指導', value: 1 },
        { name: '2人同時指導', value: 2 }
      ],

      unit: [
        { name: '未選択', value: 0 },
        { name: '1件口', value: 1 },
        { name: '2件口', value: 2 }
      ],

      preferred_contact: [
        { name: '未選択', value: 0 },
        { name: '自宅', value: 1 },
        { name: '携帯', value: 2 },
        { name: '勤務先', value: 3 },
        { name: 'その他', value: 4 }
      ]
    }
  },
  computed: {
    families () {
      return this.$store.getters.families
    },

    orderedFamilies () {
      if (this.sortState === '' || this.sortState === 'asc') {
        return _.orderBy(this.families, this.asc)
      } else if (this.sortState === 'desc') {
        return _.orderBy(this.families, this.desc).reverse()
      }
    },

    // validation
    family_idErrors () {
      return this.student.family_id ? [] : ['家庭選択']
    },

    f_name_kanaErrors () {
      return this.student.f_name_kana ? [] : ['せい']
    },

    l_name_kanaErrors () {
      return this.student.l_name_kana ? [] : ['めい']
    },

    genderErrors () {
      return this.student.gender ? [] : ['性別']
    },

    birthdayErrors () {
      return this.student.birthday ? [] : ['生年月日']
    },

    service_period_startErrors () {
      return this.student.service_period_start ? [] : ['役務開始']
    },

    service_period_endErrors () {
      return this.student.service_period_end ? [] : ['役務終了']
    },

    errors () {
      let errors = [].concat(
        this.family_idErrors,
        this.f_name_kanaErrors,
        this.l_name_kanaErrors,
        this.genderErrors,
        this.birthdayErrors,
        this.service_period_startErrors,
        this.service_period_endErrors,
      )
      let errorsJoin = errors.join('・')
      // console.log(errorsJoin)
      return errorsJoin
    },
    valid: function () {
      return !this.errors
    }
  },
  watch: {
    'watchStudent.state': function (now, old) {
      if (now) {
        this.student.state = now.value
      }
    },

    'watchStudent.gender': function (now, old) {
      if (now) {
        this.student.gender = now.value
      }
    },

    'watchStudent.school_type': function (now, old) {
      if (now) {
        this.student.school_type = now.value
      }
    },

    'watchStudent.inheritance_result': function (now, old) {
      if (now) {
        this.student.inheritance_result = now.value
      }
    },

    'watchStudent.priority': function (now, old) {
      if (now) {
        this.student.priority = now.value
      }
    },

    'watchSearch.relationship': function (now, old) {
      if (now) {
        this.search.relationship = now.value
      }
    },

    'watchSearch.pref': function (now, old) {
      if (now) {
        this.search.pref = now.value
      }
    },

    'watchSearch.guidance_type': function (now, old) {
      if (now) {
        this.search.guidance_type = now.value
      }
    },

    'watchSearch.unit': function (now, old) {
      if (now) {
        this.search.unit = now.value
      }
    },

    'watchSearch.preferred_contact': function (now, old) {
      if (now) {
        this.search.preferred_contact = now.value
      }
    },

    'watchSearch.not_relationship': function (now, old) {
      if (now) {
        this.search.not_relationship = now.value
      }
    },

    'watchSearch.not_pref': function (now, old) {
      if (now) {
        this.search.not_pref = now.value
      }
    },

    'watchSearch.not_guidance_type': function (now, old) {
      if (now) {
        this.search.not_guidance_type = now.value
      }
    },

    'watchSearch.not_unit': function (now, old) {
      if (now) {
        this.search.not_unit = now.value
      }
    },

    'watchSearch.not_preferred_contact': function (now, old) {
      if (now) {
        this.search.not_preferred_contact = now.value
      }
    },

    'student.birthday': function (val) {
      this.student.age = this.calcAge(val)
    }
  },
  methods: {
    select (selectedOption, id) {
      // console.log(selectedOption)
      // console.log(selectedOption.name)
      // console.log(selectedOption.value)
    },

    calcAge (birthday) {
      var x = Date.parse(birthday) // 変換(ミリ秒が返される)
      var date = new Date(x) // ミリ秒をnew Dateに渡す
      var ageDifMs = Date.now() - date
      var ageDate = new Date(ageDifMs)
      return ageDate.getUTCFullYear() - 1970
    },

    sort (header) {
      if (this.sortState === '' || this.sortState === 'desc') {
        this.sortState = 'asc'
        this.asc = header
      } else if (this.sortState === 'asc') {
        this.sortState = 'desc'
        this.desc = header
      }
    },

    searchTable (e) {
      this.$store.dispatch('SEARCH', {
        this: this,
        e: e,
        obj: obj
      })
    },

    getId (family) {
      this.student.family_id = family.id
      this.student.f_name = family.f_name
      this.student.f_name_kana = family.f_name_kana
    },

    postStudent () {
      if (this.student.family_id) {
        this.$store.dispatch('postStudent', {
          this: this,
          student: this.student,
          watchStudent: this.watchStudent,
          reset: this.reset
        })
        this.save()
      } else {
        alert('紐づける家庭を選択して下さい。')
      }
    },

    save () {
      // alert('save')
      let arr = []
      let obj = {
        state: this.watchStudent.state,
        f_name: this.student.f_name,
        l_name: this.student.l_name,
        f_name_kana: this.student.f_name_kana,
        l_name_kana: this.student.l_name_kana,
        gender: this.watchStudent.gender,
        birthday: this.student.birthday,
        school_type: this.watchStudent.school_type,
        school_name: this.student.school_name,
        grade_flag: this.student.grade_flag,
        guidance_detail: this.student.guidance_detail,
        takeover_time: this.student.takeover_time,
        inheritance_result: this.watchStudent.inheritance_result,
        next_contact_date: this.student.next_contact_date,
        priority: this.watchStudent.priority,
        service_period_start: this.student.service_period_start,
        service_period_end: this.student.service_period_end,
        note: this.student.note
      }
      arr.push(obj)
      let setjson = JSON.stringify(obj)
      localStorage.setItem('StudentsAdd', setjson)
    },

    get () {
      // alert('get')
      let getjson = localStorage.getItem('StudentsAdd')
      let obj = JSON.parse(getjson)

      this.watchStudent.state = obj['state']
      this.student.f_name = obj['f_name']
      this.student.l_name = obj['l_name']
      this.student.f_name_kana = obj['f_name_kana']
      this.student.l_name_kana = obj['l_name_kana']
      this.watchStudent.gender = obj['gender']
      this.student.birthday = obj['birthday']
      this.watchStudent.school_type = obj['school_type']
      this.student.school_name = obj['school_name']
      this.student.grade_flag = obj['grade_flag']
      this.student.guidance_detail = obj['guidance_detail']
      this.student.takeover_time = obj['takeover_time']
      this.watchStudent.inheritance_result = obj['inheritance_result']
      this.student.next_contact_date = obj['next_contact_date']
      this.watchStudent.priority = obj['priority']
      this.student.service_period_start = obj['service_period_start']
      this.student.service_period_end = obj['service_period_end']
      this.student.note = obj['note']
      // console.log(obj)
    },

    reset () {
      this.watchStudent.state = 0
      this.student.f_name = ''
      this.student.l_name = ''
      this.student.f_name_kana = ''
      this.student.l_name_kana = ''
      this.watchStudent.gender = 0
      this.student.birthday = '0001/01/01'
      this.watchStudent.school_type = 0
      this.student.school_name = ''
      this.student.grade_flag = 0
      this.student.guidance_detail = ''
      this.student.takeover_time = ''
      this.watchStudent.inheritance_result = 0
      this.student.next_contact_date = ''
      this.watchStudent.priority = 0
      this.student.service_period_start = '0001/01/01'
      this.student.service_period_end = '0001/01/01'
      this.student.note = ''
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.get()
    })
  },
  beforeRouteLeave (to, from, next) {
    this.save()
    next()
  },
  route: {
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.form-wrapper {
  overflow: scroll;
  height: calc(100vh - 400px);
}
.errors {
  color: red;
}
.fa-user-plus {
  margin-right: 5px;
}
.u-btn {
  margin-top: 1rem;
}
button {
  background-color: var(--color-point);
  color: #fff;
  margin-bottom: 13px;
  font-size:1rem;
  font-weight: bold;
  width: 100%;
  text-align: center;
  padding: 1em;
  border: 0;
  cursor: pointer;
  transition: opacity 0.5s ease-in-out;
  &:hover {
    opacity: .8;
  }
  &:focus {
    outline: 0;
  }
}
.table {
  margin-top: 0 !important;
}
.th, .td {
  padding: 0.5rem 0.5rem !important;
  border-right: solid 1px #ccc;
}
.th {
  cursor: pointer;
}
.select {
  padding: 0 !important;
}
input {
  width: 100%;
  min-width: 100px;
  padding: 0;
  outline: 0;
  border: none;
}
.clicked {
  background: #41B883;
  font-weight: bold;
  color: #fff;
}
</style>

<style lang="scss">
.StudentsAdd {
  .multiselect {
    min-height: 23px;
    min-width: 100px;
  }
  .multiselect__tags {
    border: solid 1px #ccc;
    min-height: 23px;
    padding: 0px 23px 0 2px;
    border-radius: 0;
    border: none;
    margin: 1px;
  }
  .multiselect__tags-wrap {
    background: red;
  }
  .multiselect__input {
    margin-bottom: 0;
    height: 23px;
  }
  .multiselect__select {
    height: 23px;
    width: 26px;
    top: 2px;
    padding: 0;
    &:before {
      top: 75%;
    }
  }
  .multiselect__single {
    margin-top: 3px;
    margin-bottom: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// StudentsAdd.vue?293403b4